import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardMedia, Typography, Button, Box, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import { AccessTime, DateRange, Business, Info } from '@mui/icons-material';

const CampanhaCard = ({ campanha }) => {
  return (
    <Card sx={{ maxWidth: 345 }}>
      {/* Se houver uma imagem associada à campanha, ela será exibida aqui */}
      {campanha.imagem && (
        <CardMedia
          component="img"
          height="140"
          image={campanha.imagem}
          alt={`Imagem da campanha ${campanha.nome}`}
        />
      )}
      <CardContent>
        <Typography variant="h5" component="div" gutterBottom>
          {campanha.nome}
        </Typography>

        <Box display="flex" alignItems="center" mb={1}>
          <Business sx={{ mr: 0.5 }} color="action" />
          <Typography variant="body2" color="text.secondary">
            {campanha.instituicao ? campanha.instituicao.nome : 'Instituição não especificada'}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" mb={1}>
          <DateRange sx={{ mr: 0.5 }} color="action" />
          <Typography variant="body2" color="text.secondary">
            {new Date(campanha.dataInicio).toLocaleDateString()} -{' '}
            {new Date(campanha.dataFim).toLocaleDateString()}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" mb={1}>
          <AccessTime sx={{ mr: 0.5 }} color="action" />
          <Typography variant="body2" color="text.secondary">
            Status: {campanha.status}
          </Typography>
        </Box>

        {/* Exemplo de uso de Chip para indicar o status da campanha */}
        <Chip
          label={campanha.status.charAt(0).toUpperCase() + campanha.status.slice(1)}
          color={campanha.status === 'ativa' ? 'success' : 'default'}
          sx={{ mb: 2 }}
        />

        <Button
          component={Link}
          to={`/campanhas/${campanha.id}`}
          variant="contained"
          color="primary"
          fullWidth
          startIcon={<Info />}
        >
          Ver Detalhes
        </Button>
      </CardContent>
    </Card>
  );
};

// Adicionar validação de prop types
CampanhaCard.propTypes = {
  campanha: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    nome: PropTypes.string.isRequired,
    imagem: PropTypes.string,
    instituicao: PropTypes.shape({
      nome: PropTypes.string.isRequired,
    }),
    dataInicio: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    dataFim: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default CampanhaCard;
